import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  headerCard: {
    color: TextColors.light,

    '& $superHeading': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  headerCard: {
    color: TextColors.dark,

    '& $superHeading': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    headerCard: {
      '&.dark-theme': darkTheme.headerCard,
      '&.light-theme': lightTheme.headerCard,

      '&.with-featured': {
        marginBottom: muiTheme.spacing(3),
      },
    },
    superHeading: {
      '&.MuiTypography-root': {
        '&:not(:last-child)': {
          marginBottom: muiTheme.spacing(2),
        },
      },
    },
    title: {
      '&.Muitypography-root': {
        color: 'inherit',
        marginBottom: '-.125em',
      },
    },
    cards: {
      '& > * + *': {
        marginTop: muiTheme.spacing(4),

        [muiTheme.breakpoints.up('md')]: {
          marginTop: muiTheme.spacing(10),
        },
      },
    },
    ctaCard: {
      [muiTheme.breakpoints.up('md')]: {
        height: '320px',
      },
    },
  }),
  { name: 'GenFeaturedContentColumn' },
);

export default useStyles;
